const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const saleType = state => state.app.saleType
const currentMap = state => state.app.currentMap
const currentDueDate = state => state.app.currentDueDate
const currentItemsOrders = state => state.app.currentItemsOrders

export {
  config,
  palette,
  isLoading,
  saleType,
  currentItemsOrders,
  currentDueDate,
  currentMap
}



// WEBPACK FOOTER //
// ./src/store/getters.js